export default "__VITE_ASSET__aMT0RM7v__"